import { createSlice } from "@reduxjs/toolkit";
import { GetAllDropDownData } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import { GetAllEmpolyee, ViewEmpolyee } from "./empolyeeApi";

const empolyeeSlice = createSlice({
  name: "empolyee",
  initialState: {
    isExcelValid: false,
    excelData: [],
    validationErrors: [],
    tableData: [],
    systemPrivillageList: [],
    empolyeeDataList: [],
    empolyeeSingleData: null,
    empolyeeFilters: {
      emp_name: "",
      branch_id: "",
      emp_natid: "",
      emp_email: "",
      syspri_id: "",
    },
  },
  reducers: {
    setExcelData: (state, action) => {
      state.excelData = action.payload;
    },
    setIsExcelValid: (state, action) => {
      state.isExcelValid = action.payload;
    },
    setValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
    },
    deleteRow: (state, action) => {
      const rowNumToDelete = action.payload;
      state.tableData = state.tableData.filter(
        (row) => row.rowNum !== rowNumToDelete
      );
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    handleEmpolyeeFilter: (state, action) => {
      state.empolyeeFilters[action?.payload?.check] = action?.payload?.value;
    },
    handleEmpolyeeReset: (state, _) => {
      state.empolyeeFilters = {
        branch_id: "",
        emp_email: "",
        emp_name: "",
        emp_natid: "",
        syspri_id: "",
      };
    },
    updateRowData: (state, action) => {
      const { rowNum, updatedData, isValid } = action.payload;
      state.tableData = state.tableData.map((row) =>
        row.rowNum === rowNum
          ? {
              ...updatedData,
              rowNum,
              isValid,
              errors: isValid ? [] : row.errors,
            }
          : row
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllDropDownData.fulfilled, (state, action) => {
        state.systemPrivillageList = action.payload?.data?.system_privileges;
      })
      .addCase(GetAllEmpolyee.fulfilled, (state, action) => {
        state.empolyeeDataList = action.payload?.data?.employee_details;
      })
      .addCase(ViewEmpolyee.fulfilled, (state, action) => {
        state.empolyeeSingleData = action.payload?.data?.employee_data;
      });
  },
});

export const {
  setExcelData,
  setIsExcelValid,
  setTableData,
  updateRowData,
  deleteRow,
  handleEmpolyeeFilter,
  handleEmpolyeeReset,
  setValidationErrors,
} = empolyeeSlice.actions;

export default empolyeeSlice.reducer;
